module.exports = __webpack_public_path__ + "img/neighborhood_map.png";